import React from 'react';

import Compare from '../../compare/components/compare';
import LeftMenuContainer from '../../left-menu/left-menu-container';
import { Helpers } from "../../core/src/helpers";
import TopBanner from '../../top-banner/top-banner';
import SearchResults from '../../search-filter/components/search-results';
import SearchTopBar from '../../search-filter/components/search-top-bar';
import SearchHits from '../../search-filter/components/search-hits';
import SearchLoadMore from '../../search-filter/components/search-load-more';
import SearchSort, { TrackSort }  from '../../search-filter/components/search-sort';
import VWAProductList from './vwa-product-list';
import VWAFilterCrumb from './vwa-filter-crumbs';
import VWAMobileSort from './vwa-mobile-sort';
import FilterMenu from '../../filters';
import ABTest from '../../abtest/components/abtest';
import ProductResults from '../../product/components/product-results';

import '../css/vwa.less';

const { memoize } = Helpers;


const SORT_OPTIONS = [
    { label: 'Best seller', field: 'rank.default', order: 'asc' },
    { label: 'Lowest price', field: 'salePrice', order: 'asc' },
    { label: 'Highest price', field: 'salePrice', order: 'desc' },
    { label: 'Name', field: 'name>keyword', order: 'asc' },
    { label: 'Rating', field: 'rating', order: 'desc' },
    { label: 'Newest', field: 'rank.newest', order: 'asc' }
];


/**
 * On initial page load Swiftype results are fetched all at once during the SSR stage.
 * That's done to capture the top most relevant results for the keyword and to
 * be able to sort those results through JavaScript later without hitting the
 * Swiftype API (it mixes irrelevant results into the list when sorting).
 *
 * Due to this fact pagination on DLP is entirely controlled by this component's state.
 * Also keep in mind that pagination works with SSR enabled only.
 */
class VWA extends React.PureComponent {
    static defaultProps = {
        heroBanner: {},
        categoryFilters: {}
    }

    constructor(props) {
        super(props);
    }

    getTabs = memoize((defaultExpandedFilters) => {
        let tabs = [{
            Component: FilterMenu,
            title: 'Filter',
            active: true,
            tabProps: {
                useAlias: true,
                defaultExpandedFilters
            }
          },{
              Component: (props) => {
                  return <VWAMobileSort options={SORT_OPTIONS} {...props}/>
              },
              title: 'Sort',
              active: false,
              mobileOnly: true
          }
          ,{
            Component: Compare,
            title: 'Compare',
            active: false
          }];

        return tabs;
    });

    render() {
        const { categoryFilters, heroBanner, filters,productCard  } = this.props;
        const { facets, filterTitle, defaultExpandedFilters=6  } = categoryFilters;

        return (
            <div className='clearfix vwa'>
                <LeftMenuContainer
                    defaultVisibility={true}
                    tabs={this.getTabs(defaultExpandedFilters * 1)}
                    sticky={false}
                    lockMenu={true}
                />
                <ProductResults>
                    <SearchTopBar>
                        <h1>{filterTitle}</h1>
                        <VWAFilterCrumb  useAlias={true}/>
                        <SearchHits />
                        <TrackSort>
                            {
                                ({trackSort}) => <SearchSort className='sortby' options={SORT_OPTIONS} onSort={trackSort}/>
                            }
                        </TrackSort>
                    </SearchTopBar>
                    <SearchResults>
                        {({ results }) => (
                            <React.Fragment>
                                <TopBanner
                                    html={heroBanner.bannerHtml}
                                    countDownEnabled={heroBanner.countDown}
                                    endtime={heroBanner.endTime}
                                    countDownFormat={heroBanner.countDownFormat}
                                    countDownMessage={heroBanner.countDownMessage}
                                    bannerUrl={heroBanner.bannerUrl}
                                    dataAttributes={{'data-filters' : filters}}
                                />
                                <VWAProductList results={results} productCard={productCard} />
                                <SearchLoadMore />
                            </React.Fragment>
                        )}
                    </SearchResults>
                </ProductResults>
            </div>
        );
    }
}

export default VWA;
